import React, {
  useState,
  useEffect,
  useReducer,
  useMemo,
} from "react";
import GlobalContext from "./GlobalContext";
import dayjs from "dayjs";
import axios from "axios";
import queryString from "query-string";

const ID_TP_COMP_FERIAS = "264f9e189b3297f77f48ac63e81c0346";
const ID_TP_COMP_FOLGA = "264f9e189b3297f77f48ac63e81c5ce3";
const ID_TP_COMP_LICENCA_MATERNIDADE =
  "55605cd248a9be824f0228922ff0e739";
const ID_TP_COMP_CONGRESSO = "55605cd248a9be824f0228922ff0ba48";
const ID_TP_COMP_LICENCA_SAUDE = "55605cd248a9be824f0228922ff0e5d4";
const ID_TP_COMP_CURSO = "55605cd248a9be824f0228922ff0bdf3"; //BORDO

let listaTipoCompromissosEscalador = [
  ID_TP_COMP_FERIAS,
  ID_TP_COMP_FOLGA,
  ID_TP_COMP_LICENCA_MATERNIDADE,
  ID_TP_COMP_CONGRESSO,
  ID_TP_COMP_LICENCA_SAUDE,
  ID_TP_COMP_CURSO,
];

function savedEventsReducer(state, { type, payload }) {
  switch (type) {
    case "push":
      return [...state, payload];
    case "update":
      return state.map((evt) =>
        evt.id === payload.id ? payload : evt
      );
    case "delete":
      return state.filter((evt) => evt.id !== payload.id);

    case "atualiza":
      return payload;
    default:
      throw new Error();
  }
}
function initEvents() {
  // const storageEvents = localStorage.getItem("savedEvents");
  // const parsedEvents = storageEvents ? JSON.parse(storageEvents) : [];
  // return parsedEvents;
  return [];
}

export default function ContextWrapper(props) {
  const [monthIndex, setMonthIndex] = useState(dayjs().month());
  const [smallCalendarMonth, setSmallCalendarMonth] = useState(null);
  const [daySelected, setDaySelected] = useState(dayjs());
  const [showEventModal, setShowEventModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [labels, setLabels] = useState([]);
  const [savedEvents, dispatchCalEvent] = useReducer(
    savedEventsReducer,
    [],
    initEvents
  );
  const [savedEventsBkp, setSavedEventsBkp] = useState([]);
  const [executado, setExecutado] = useState(false);
  const [codigo, setCodigo] = useState(
    queryString.parse(window.location.search).codigo
  );
  const [tipo, setTipo] = useState(
    queryString.parse(window.location.search).tipo
  );

  const [tipoFiltro, setTipoFiltro] = useState(0);
  const [dtInicial, setDtInicial] = useState(dayjs());
  const [dtFinal, setDtFinal] = useState(dayjs().endOf("month"));

  const [listaTiposCompromisso, setListaTiposCompromisso] = useState(
    []
  );
  const [
    listaTiposCompromissoSelecionados,
    setListaTiposCompromissoSelecionados,
  ] = useState([]);

  const [filtrarTiposCompromisso, setFiltrarTiposCompromisso] =
    useState(true);

  const [listaMedicos, setListaMedicos] = useState([]);
  const [listaMedicosBkp, setListaMedicosBkp] = useState([]);
  const [listaMedicosSelecionados, setListaMedicosSelecionados] = useState([]);

  const filteredEvents = useMemo(() => {
    return savedEvents.filter((evt) =>
      labels
        .filter((lbl) => lbl.checked)
        .map((lbl) => lbl.label)
        .includes(evt.label)
    );
  }, [savedEvents, labels]);

  const filtrarCompromissos = (compromissos) => {
    let compromissosFiltrados = compromissos.filter(
      (it) =>
        it.tipoCompromisso !== null &&
        listaTipoCompromissosEscalador.includes(
          it.tipoCompromisso._id
        )
    );
    return compromissosFiltrados;
  };

  useEffect(() => {
    //localStorage.setItem("savedEvents", JSON.stringify(savedEvents));

    async function buscar() {
      //localStorage.setItem("codigo", codigo);
      let url = `https://estsistemas.com.br:3002/app/compromissos?codigo=${codigo}`;

      if (tipo !== undefined) {
        if (tipo === "residente") {
          url = `https://estsistemas.com.br:3002/app/compromissos-residentes?codigo=${codigo}`;
        }
      }

      await axios.get(url, {}).then((response) => {
        let compromissos = response.data.compromissos;
        console.log("comppp", compromissos);

        for (let item of compromissos) {
          if (item.tipoCompromisso !== null) {
            if (
              item.tipoCompromisso._id === ID_TP_COMP_FERIAS ||
              item.tipoCompromisso._id === ID_TP_COMP_FOLGA
            ) {
              item.label = "blue";
              item.label2 = "300";
            }
            if (item.tipoCompromisso._id === ID_TP_COMP_CONGRESSO) {
              item.label = "red";
              item.label2 = "400";
            }
            if (
              item.tipoCompromisso._id ===
              ID_TP_COMP_LICENCA_MATERNIDADE
            ) {
              item.label = "purple";
              item.label2 = "400";
            }
            if (
              item.tipoCompromisso._id === ID_TP_COMP_LICENCA_SAUDE
            ) {
              item.label = "green";
              item.label2 = "300";
            }
            if (item.tipoCompromisso._id === ID_TP_COMP_CURSO) {
              item.label = "wine";
              item.label2 = "300";
            }
            if (item.extrapolou !== undefined && item.extrapolou) {
              item.label = "orange";
              item.label2 = "300";
            }
          }
        }

        let compromissos2 = JSON.parse(JSON.stringify(compromissos));

        setSavedEventsBkp(compromissos2);

        compromissos = filtrarCompromissos(compromissos);

        dispatchCalEvent({
          type: "atualiza",
          payload: compromissos,
        });
        // localStorage.setItem(
        //   "savedEvents",
        //   JSON.stringify(compromissos)
        // );
        setExecutado(true);
      });
    }

    if (!executado) {
      buscar();
    } else {
      // localStorage.setItem(
      //   "savedEvents",
      //   JSON.stringify(savedEvents)
      // );
    }
  }, [savedEvents]);

  useEffect(() => {
    setLabels((prevLabels) => {
      return [...new Set(savedEvents.map((evt) => evt.label))].map(
        (label) => {
          const currentLabel = prevLabels.find(
            (lbl) => lbl.label === label
          );
          return {
            label,
            checked: currentLabel ? currentLabel.checked : true,
          };
        }
      );
    });
  }, [savedEvents]);

  useEffect(() => {
    if (smallCalendarMonth !== null) {
      setMonthIndex(smallCalendarMonth);
    }
  }, [smallCalendarMonth]);

  useEffect(() => {
    if (!showEventModal) {
      setSelectedEvent(null);
    }
  }, [showEventModal]);

  function updateLabel(label) {
    setLabels(
      labels.map((lbl) => (lbl.label === label.label ? label : lbl))
    );
  }

  useEffect(() => {
    async function buscarTiposCompromisso() {
      let url = "https://estsistemas.com.br:3002/app/tipos-compromisso";

      if (tipo !== undefined) {
        if (tipo === "residente") {
          url = url + "-residente";
        }
      }

      await axios
        .get(url, {})
        .then((response) => {
          let tiposCompromisso = response.data.tiposCompromisso;
          tiposCompromisso = tiposCompromisso.map(
            (tipoCompromisso) => {
              tipoCompromisso.label = tipoCompromisso.desc;
              tipoCompromisso.value = tipoCompromisso._id;
              return tipoCompromisso;
            }
          );

          setListaTiposCompromisso(tiposCompromisso);

          setListaTiposCompromissoSelecionados(
            tiposCompromisso.filter((it) =>
              listaTipoCompromissosEscalador.includes(it._id)
            )
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }

    buscarTiposCompromisso();
  }, []);

  useEffect(() => {
    async function getMedicos() {
      await axios
        .get("https://estsistemas.com.br:3002/app/medicos", {})
        .then((response) => {
          let medicos = response.data.medicos;
          medicos = medicos.map((med) => {
            med.label = med.nome;
            med.value = med._id;
            return med;
          });

          setListaMedicos(medicos);
          setListaMedicosBkp(medicos);
          setListaMedicosSelecionados(medicos);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    async function getResidentes() {
      await axios
        .get("https://estsistemas.com.br:3002/app/residentes", {})
        .then((response) => {
          let medicos = response.data.medicos;
          medicos = medicos.map((med) => {
            med.label = med.nome;
            med.value = med._id;
            return med;
          });

          setListaMedicos(medicos);
          setListaMedicosBkp(medicos);
          setListaMedicosSelecionados(medicos);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (tipo === undefined) {
      getMedicos();
    } else {
      if (tipo === "residente") {
        getResidentes();
      } else {
        getMedicos();
      }
    }
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        monthIndex,
        setMonthIndex,
        smallCalendarMonth,
        setSmallCalendarMonth,
        daySelected,
        setDaySelected,
        showEventModal,
        setShowEventModal,
        dispatchCalEvent,
        selectedEvent,
        setSelectedEvent,
        savedEvents,
        savedEventsBkp,
        setSavedEventsBkp,
        setLabels,
        labels,
        updateLabel,
        filteredEvents,
        tipoFiltro,
        setTipoFiltro,
        dtInicial,
        setDtInicial,
        dtFinal,
        setDtFinal,
        listaTiposCompromisso,
        listaTiposCompromissoSelecionados,
        setListaTiposCompromissoSelecionados,
        filtrarTiposCompromisso,
        setFiltrarTiposCompromisso,
        listaMedicos,
        listaMedicosBkp,
        setListaMedicos,
        setListaMedicosBkp,
        listaMedicosSelecionados,
        setListaMedicosSelecionados
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
}
